// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionControlPlane = {
  controlPlaneFields: {
    activeWorkers: "活跃执行器",
    controlPlaneState: "控制面状态",
    criticalAlerts: "严重告警",
    warningAlerts: "预警告警",
    redis: "Redis 调度",
    pendingOldest: "最老待处理",
    runningOldest: "最老运行中",
    leaseRisk: "租约风险",
    cancelRequested: "取消请求中",
    pendingWorkers: "派发执行器",
    retryWorkers: "重试执行器",
    recoveryWorkers: "恢复执行器",
    cleanupWorkers: "清理执行器",
    recentEventWindow: "统计窗口",
    recentClaimConflicted: "近期 claim 冲突",
    recentRateLimited: "近期限流阻塞",
    recentCapabilityMismatched: "近期能力不匹配",
    recentDispatchFailed: "近期派发失败",
    capabilityBlockedActions: "能力阻塞动作",
    workerPolicyCoverage: "worker 策略覆盖",
    workerPolicies: "worker 策略",
    remediation: "整改建议",
    actionBacklog: "动作 backlog",
  },
  remediationFields: {
    triggerShort: "触发器 {value}",
    capabilityShort: "能力 {value}",
  },
  remediationPriorities: {
    warning: "预警",
    critical: "严重",
  },
  remediationActions: {
    bring_up_stale_running_recovery_worker: "补齐 stale recovery worker",
    bring_up_failed_cleanup_worker: "补齐 failed cleanup worker",
    bring_up_auto_retry_worker: "补齐 auto retry worker",
    bring_up_dispatch_worker: "补齐 dispatch worker",
    add_capable_worker: "补齐具备能力的 worker",
    increase_running_limit_or_scale_workers: "提高运行上限或扩容 worker",
    increase_pending_limit_or_reduce_submit_rate: "提高待处理上限或降低提交速率",
    investigate_dispatch_failures: "排查派发失败链路",
    drain_retryable_failed_backlog: "清理可重试失败积压",
    reduce_claim_contention: "降低 claim 竞争",
    rebalance_capacity_or_submission_rate: "重平衡容量或提交速率",
    align_worker_capabilities: "对齐 worker capability",
    drain_aged_backlog: "清理老化 backlog",
  },
  remediationReasons: {
    missing_worker_policy_coverage: "缺失 worker 策略覆盖",
    missing_capable_worker: "缺失可执行该动作的 worker",
    running_limit_reached: "运行并发已达上限",
    pending_limit_reached: "待处理队列已达上限",
    recent_dispatch_failed: "近期派发失败",
    retry_pressure: "重试压力积压",
    claim_conflicted: "claim 竞争冲突",
    rate_limited: "派发触发限流",
    capability_mismatched: "worker 能力不匹配",
    queue_aging: "队列老化",
  },
  workerPolicy: {
    covered: "已覆盖 {count}",
    missing: "缺失 {count}",
    coverageSummary: "后台处理能力覆盖：{covered} / {total}",
    noActiveWorkers: "暂无可用处理节点",
    currentState: "当前状态：{value}",
    impact: "影响：{value}",
    capabilityWithCount: "{label}（{count}）",
    capabilities: {
      pendingDispatch: "任务分发",
      autoRetry: "自动重试",
      staleRunningRecovery: "异常恢复",
      failedCleanup: "失败实例清理",
    },
    impacts: {
      pendingDispatch: "新任务不会自动派发执行",
      autoRetry: "可重试任务不会自动重新调度",
      staleRunningRecovery: "异常运行中的任务不会自动恢复处理",
      failedCleanup: "失败后的实例清理不会自动执行",
      unknown: "该处理能力当前未覆盖",
    },
  },
  actionBacklog: {
    currentState: "当前状态：{value}",
    workerCoverage: "可处理节点：{count}",
    capacity: "运行中 {running}/{runningLimit} · 待处理 {pending}/{pendingLimit}",
    impacts: {
      capabilityBlocked: "缺少可执行该动作的处理节点",
      dispatchFailed: "该动作近期出现派发失败，需要排查执行链路",
      retryPending: "该动作存在待自动重试任务",
      queuePressure: "该动作存在队列压力",
      normal: "当前运行平稳",
    },
  },
  alertStates: {
    normal: "正常",
    warning: "预警",
    critical: "严重",
  },
  backlogStates: {
    normal: "正常",
    warning: "预警",
    saturated: "拥塞",
  },
  backlogMetrics: {
    claimConflictedShort: "冲突 {count}",
    rateLimitedShort: "限流 {count}",
    capabilityMismatchedShort: "能力 {count}",
    dispatchFailedShort: "派发失败 {count}",
    retryableFailedShort: "可重试失败 {count}",
    autoRetryScheduledShort: "待重试 {count}",
    pendingAgeShort: "待处理年龄 {count}s",
    runningAgeShort: "运行年龄 {count}s",
  },
} as const;
